import './styles/Splash.scss';
import { AppContext } from '../Context';
import { Fragment, useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { System_DeviceOrientationMap } from '../assets/keyMap';

//components
import SvgFramesAnimator from '../components/SvgFramesAnimator';

//classes
import SvgFrameAnimatorSetting from '../classes/svgFrameAnimatorSetting';

//assets
import SplashAnimation from '../assets/videos/splashAnimation.mp4';

//nonstate
const nonstate = {
    // 'assetsLoaderInterval': 1500
}

interface Props {
    // svgSettings: SvgFrameAnimatorSetting[],
    /*splashTimeoutDuration: number*/
    splashDelayAfterAnimation: number
}

const Splash: React.FC<Props> = ({ /*svgSettings,*/ /*splashTimeoutDuration*/ splashDelayAfterAnimation }) => {
    //context
    const appContext = useContext(AppContext);
    // //states
    // const [studioLabelFade, SetStudioLabelFade] = useState('');
    // const [loaderIndicator, SetLoaderIndicator] = useState('on'); //on - off 
    // //refs variables
    // const splashTimeLoadedRef = useRef(false);
    // const assetsReadyRef = useRef(false);
    // //refs intervals
    // const assetsLoaderIntervalRef = useRef<any>(null);
    const [videoIsReady, SetVideoIsReady] = useState(false);

    //refs intervals
    const splashTimeoutRef = useRef<any>(null);
    //routers
    const history = useHistory();

    //watchers
    useEffect(() => {
        // splashTimeoutRef.current = setTimeout(() => {
        //     // history.push('/Login');
        // }, splashTimeoutDuration);
        appContext.SetDatabaseShouldShowWaitScreen(false);
        return (() => {
            // clearInterval(assetsLoaderIntervalRef.current!);
            // assetsLoaderIntervalRef.current = null;

            // if(splashTimeoutRef.current != null) {
            //     clearTimeout(splashTimeoutRef.current);
            //     splashTimeoutRef.current = null;
            // }
            appContext.SetDatabaseShouldShowWaitScreen(true);
        });
    }, []);

    // useEffect(() => {
    //     if (svgSettings.length > 0) {
    //         const splashTimeout = setTimeout(() => {
    //             clearTimeout(splashTimeout!);
    //             splashTimeLoadedRef.current = true;
    //         }, splashTimeoutDuration);
    //         const labelFadeTimeout = setTimeout(() => {
    //             clearTimeout(labelFadeTimeout!);
    //             SetStudioLabelFade('in');
    //         }, 750);
    //     }
    // }, [svgSettings]);

    //watch for splashTimeLoaded(minimum show splash screen) && splitAssetsLoaded, proceeds into the app
    // useEffect(() => {
    //     if (splashTimeLoaded && appContext.splitAssetsLoader.assetsReady) {
    //         history.push('/Home');
    //     }
    // }, [splashTimeLoaded, appContext.splitAssetsLoader]);

    //watch for assetsloader incoming  message, starts assetsLoaderInterval
    // useEffect(() => {
    //     if (appContext.splitAssetsLoader.message.length > 0) {
    //         if (assetsLoaderIntervalRef.current == null) {
    //             assetsLoaderIntervalRef.current = setInterval(() => {
    //                 SetLoaderIndicator('off');
    //                 setTimeout(() => SetLoaderIndicator('on'), 250)
    //                 //check for split assets ready state
    //                 if(splashTimeLoadedRef.current && assetsReadyRef.current)
    //                     history.push('/Home');
    //             }, nonstate.assetsLoaderInterval);
    //         }
    //     }
    // }, [appContext.splitAssetsLoader.message]);

    //watch for assetsLoaded update assetsReadyRef
    // useEffect(() => {
    //     assetsReadyRef.current = appContext.splitAssetsLoader.assetsReady;
    // }, [appContext.splitAssetsLoader.assetsReady]);

    //test
    // useEffect(()  => {
    //     console.log('SplashTest: ' + JSON.stringify(appContext.splitAssetsLoader));
    // }, [appContext.splitAssetsLoader.message]);

    //render functions
    // const RenderSplashAnimation = () => {
    //     const svgSetting: SvgFrameAnimatorSetting = GetSvgSettingByAnimation('splashAnimation');
    //     return (
    //         <SvgFramesAnimator
    //             frames={svgSetting.frames}
    //             frameCount={svgSetting.framesCount}
    //             fps={svgSetting.fps}
    //             repeat={svgSetting.repeat}
    //         />
    //     );
    // }

    //exe functions
    // const GetSvgSettingByAnimation = (animationName: string) => {
    //     let svgSetting = {} as SvgFrameAnimatorSetting;
    //     svgSettings.map((_svgSetting: SvgFrameAnimatorSetting) => {
    //         if (_svgSetting.animationName == animationName)
    //             svgSetting = _svgSetting;
    //     });
    //     return svgSetting;
    // }

    return (
        <div className={'Splash ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {/*
                svgSettings.length > 0 ?
                    <Fragment>
                        {RenderSplashAnimation()}
                        <span className={'studio-lbl ' + studioLabelFade}>Infinity<br />Propagation<span className='copyright-lbl'>©</span></span>
                    </Fragment>
                    :
                    null
            */}
            {/*<span className={'assets-loader-lbl ' + (loaderIndicator)} style={
                loaderIndicator == 'on' ?
                {transition: `opacity ${nonstate.assetsLoaderInterval/1000}s linear`}
                :
                {}
            }>{appContext.splitAssetsLoader.message}</span>*/}
            <video
                className='Splash-video'
                autoPlay={true}
                loop={false}
                muted
                onEnded={() => setTimeout(() => {history.push('/Login')}, splashDelayAfterAnimation)}
                preload='auto'
                playsInline
                onCanPlay={() => {
                    SetVideoIsReady(true);
                }}
            >
                <source src={SplashAnimation} type="video/mp4"/>
            </video>
            {/** to block the default video buffering */}
            <div className={'Splash-mask ' + (videoIsReady ? 'hide' : '')} />
        </div>
    );
}
export default Splash;